import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getGoal = createAsyncThunk(
  "admin/allGoal",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/goal/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleGoal = createAsyncThunk(
  "admin/singleGoal",
  async (GoalId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/goal/${GoalId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addGoal = createAsyncThunk(
  "admin/addGoal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/goal/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editGoal = createAsyncThunk(
  "admin/editGoal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/goal/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteGoal = createAsyncThunk(
  "admin/deleteGoal",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/goal/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  goalLoading: false,
};
const goalSlice = createSlice({
  name: "goalSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGoal.fulfilled, (state, action) => {
      state.goalData = action.payload.data;
      state.goalLoading = false;
    });
    builder.addCase(getSingleGoal.fulfilled, (state, action) => {
      state.singleGoalData = action.payload.data;
    });
  },
});

export default goalSlice.reducer;
